import { IconProps } from './IconProps';

export const FacebookWhite = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Combined Shape</title>
      <g
        id="Icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="icon-/-16-/-social-/-fb" fill="#FFFFFF">
          <path
            d="M8,-1.77635684e-15 C12.4,-1.77635684e-15 16,3.62011173 16,8.04469274 C16,12.0223464 13.1111111,15.3296089 9.33333333,16 L9.28828829,15.9642136 C9.3033033,15.9612958 9.31831832,15.958327 9.33333333,15.9553073 L9.33333333,10.2793296 L11.1111111,10.2793296 L11.4666667,8.04469274 L9.33333333,8.04469274 L9.33333333,6.48044693 C9.33333333,5.8547486 9.55555556,5.36312849 10.5333333,5.36312849 L11.5555556,5.36312849 L11.5555556,3.30726257 C10.9777778,3.21787709 10.3555556,3.12849162 9.77777778,3.12849162 C7.95555556,3.12849162 6.66666667,4.24581006 6.66666667,6.25698324 L6.66666667,8.04469274 L4.66666667,8.04469274 L4.66666667,10.2793296 L6.66666667,10.2793296 L6.66666667,15.9553073 L6.711,15.963 L6.66666667,16 C2.88888889,15.3296089 0,12.0223464 0,8.04469274 C0,3.62011173 3.6,-1.77635684e-15 8,-1.77635684e-15 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </svg>
  );
};

